module.exports = __webpack_public_path__ + "img/sundas-rashid.fb3ec93a.jpg";